import React from 'react';
import {Image, StyleSheet} from 'react-native';
import {getDescriber} from '../../home/descriptor/DescriptorType';

export const ProductImage = React.memo(({imageUrl}: {imageUrl?: string}) => {
  const {getPlaceholderImage} = getDescriber();

  if (!imageUrl) {
    return getPlaceholderImage();
  }

  return (
    <Image
      accessible
      accessibilityLabel="Product image"
      accessibilityRole="image"
      style={styles.productImage}
      source={{uri: imageUrl}}
      resizeMode="cover"
    />
  );
});

const styles = StyleSheet.create({
  productImage: {
    width: 180,
    height: 180,
  },
});

ProductImage.displayName = 'ProductImage';
